import "./App.css";
import {Routes, Route} from 'react-router-dom'
import Index from "./Pages/Index/Index";

import About from "./Pages/About";
import Services from "./Pages/Services";
import PageConstruction from "./Pages/Construction";
import PageConsultation from './Pages/Consultation'
import PageEstimating from "./Pages/Estimting"
import PageOngoingMaintenance from "./Pages/OngoingMaintenance"
import PageDesign from "./Pages/Design"

import Projects from "./Pages/Projects";
import PagePalmBeach from "./Pages/Projects/PalmBeach";
import PageBalMain from "./Pages/Projects/BalMain";
import PageHaberField from "./Pages/Projects/HaberField";
import PageRoselle from "./Pages/Projects/Roselle";
import PageBondi from "./Pages/Projects/Bondi";
import PageMosman from "./Pages/Projects/Mosman";
import PageEarlwood from "./Pages/Projects/Earlwood";
import PageDarlingPoint from "./Pages/Projects/DarlingPoint";
import PageCammeray from "./Pages/Projects/Cammeray";
import PageCastleHill from "./Pages/Projects/CastleHill";
import PageHaberfieldTraditional from './Pages/Projects/HaberfieldTraditional'
import PageBalmoral from "./Pages/Projects/Balmoral";
import PageStrathField from "./Pages/Projects/StrathField";
import PageLaneCove from "./Pages/Projects/LaneCove";
import PageCheltnhem from "./Pages/Projects/Cheltanhem";
import PagePaddington from "./Pages/Projects/Paddington";

import Journal from "./Pages/Journal";
import Contact from "./Pages/Contact";

import Shop from "./Pages/Shop";
import PageShopContemporaryCyllinder from "./Pages/Shop/ContemporaryCyllinder";
import PageShopLowCyllinder from "./Pages/Shop/LowCyllinder";
import PageShopTallCyllinder from "./Pages/Shop/TallCyllinder";
import PageShopBulletBowl from "./Pages/Shop/BulletBowl";
import PageShopShallowBowl from "./Pages/Shop/ShallowBowl";
import PageShopWineGlassPlanter from "./Pages/Shop/WineGlassPlanter";

import Cart from "./Pages/Cart";









function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path='/construction' element={<PageConstruction />} />
      <Route path='/consultation' element={<PageConsultation />} /> 
      <Route path='/estimating' element={<PageEstimating />} />
      <Route path='/maintenance' element={<PageOngoingMaintenance />} />
      <Route path="/design" element={<PageDesign />} />
      <Route path="/project-list" element={<Projects />} />
      <Route path='/projects/palm-beach' element={<PagePalmBeach />} />
      <Route path="/projects/balmain" element={<PageBalMain />} />
      <Route path='/projects/haberfield' element={<PageHaberField />} />
      <Route path="/projects/roselle" element={<PageRoselle />} />
      <Route path="/projects/bondi" element={<PageBondi />} />
      <Route path="/projects/mosman" element={<PageMosman />} />
      <Route path="/projects/earlwood" element={<PageEarlwood />} />
      <Route path="/projects/darling-point" element={<PageDarlingPoint />} />
      <Route path="/projects/cammeray" element={<PageCammeray />} />
      <Route path="/projects/castle-hill" element={<PageCastleHill />} />
      <Route path="/projects/haberfield-2" element={<PageHaberfieldTraditional />} />
      <Route path="/projects/balmoral" element={<PageBalmoral />} />
      <Route path="/projects/strathfield" element={<PageStrathField />} />
      <Route path="/projects/lane-cove" element={<PageLaneCove />} />
      <Route path="/projects/cheltenham" element={<PageCheltnhem />} />
      <Route path="/projects/paddington" element={<PagePaddington />} />
      <Route path="/journal" element={<Journal />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/shop/contemporary-cylinder" element={<PageShopContemporaryCyllinder />} />
      <Route path="/shop/low-cylinder" element={<PageShopLowCyllinder />} />
      <Route path="/shop/tall-cylindar" element={<PageShopTallCyllinder />} />
      <Route path="/shop/bullet-bowl" element={<PageShopBulletBowl />} />
      <Route path="/shop/shallow-bowl" element={<PageShopShallowBowl />} />
      <Route path="/shop/wine-glass-planter" element={<PageShopWineGlassPlanter />} />
      <Route path="/cart" element={<Cart />} />
    </Routes>
    
  );
}

export default App;
